export default "__VITE_ASSET__BWeIYchS__"